import React, { useState, useEffect } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  CircularProgress,
  Divider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

import api from '../../services/api';
import toastError from '../../errors/toastError';

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 320,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 320,
  },
  toolbar: theme.mixins.toolbar,
  title: {
    padding: theme.spacing(2),
  },
  listItem: {
    '& .MuiListItemText-secondary': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  }
}));

const NotesDrawer = ({ open, onClose, ticketId, onSelectNote }) => {
  const classes = useStyles();
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setNotes([]);
      return;
    }

    const fetchNotes = async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/notes/${ticketId}`);
        setNotes(data);
      } catch (err) {
        toastError(err);
      }
      setLoading(false);
    };

    fetchNotes();
  }, [open, ticketId]);

  const handleNoteClick = (noteId) => {
    onSelectNote(noteId);
    onClose();
  };

  return (
    <Drawer
      className={classes.drawer}
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <div className={classes.toolbar} />
      <Typography variant="h6" className={classes.title}>
        Notas del Ticket
      </Typography>
      <Divider />
      {loading ? (
        <div className={classes.loading}><CircularProgress /></div>
      ) : (
        <List>
          {notes.length === 0 && (
            <ListItem>
              <ListItemText primary="No hay notas en este ticket." />
            </ListItem>
          )}
          {notes.map((note) => {
            const formattedDate = format(parseISO(note.createdAt), "d 'de' MMMM, HH:mm 'hs'", { locale: es });
            const formattedBody = note.body.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

            return (
              <ListItem
                button
                key={note.id}
                onClick={() => handleNoteClick(note.id)}
                className={classes.listItem}
              >
                <ListItemText
                  primary={formattedDate}
                  secondary={
                    <span
                      dangerouslySetInnerHTML={{ __html: formattedBody }}
                    />
                  }
                />
              </ListItem>
            );
          })}
        </List>
      )}
    </Drawer>
  );
};

export default NotesDrawer;